import React from "react";
import { getLabel } from "../../InitData";
import OddsVariation from "./OddsVariation";


function BetslipVariation(props){

    const selections = []; // keeping just the variated data
    for(let ks in props.betslipVariationData.selections){
    	let takeIt = props.betslipVariationData.selections[ks].closed;
    	if(!takeIt){
    		const bets = props.betslipVariationData.selections[ks].bets;
    		for(let kb in bets){
    			takeIt = takeIt || bets[kb].updated || bets[kb].closed;
    		}
    	}
    	
    	if(takeIt){
    		selections.push(props.betslipVariationData.selections[ks]);
    	}
    }
    
    const amountData = props.betslipVariationData.amountData;
    
    function goOn(){
    	props.closeFunction();
    	props.betslipVariationData.purchaseFunction();
    }

    return (
        <>
		<div className={`odds-variation-container ${props.isMobile?'odds-variation-container-mobile':''}`}>
			{selections.map((selection, selectionIndex) => {
				return <OddsVariation isMobile={props.isMobile} key={selectionIndex} selectionIndex={selectionIndex} selection={selection} />;
			})
			}
		</div>
		{
			amountData && <div className={"amountDataContainer"}>
				{
					amountData.totalOdd && <div> {getLabel('purchase.new_odd')}: <span>{amountData.totalOdd} </span></div>
				}	
			
				<div>{getLabel('purchase.new_winning')}: <span> {amountData.potentialWinning}</span> </div>
				{
					amountData.bonusAmount && <div>{getLabel('purchase.bonus')}: <span>{amountData.bonusAmount}</span> </div>
				}	

			</div>
		}
        <div className="bottoni-quota-variata" >
	    	<button onClick={props.closeFunction} className="bottone bg-arancio bianco maiuscolo">{getLabel('purchase.check_betslip')}</button>
	    	<button onClick={goOn}className="bottone bg-verde bianco maiuscolo">{getLabel('purchase.buy_anyway')}</button>
	    </div>
        </>
        
    )
}

export default BetslipVariation;